export default __webpack_public_path__ + "static/media/@ajaquedutra.a23efd47.png";